import { StaticImage } from "gatsby-plugin-image";
import React, { useEffect, useRef } from "react";

import { Button } from "@novaescola/eva-react-v2/lib/Button";
import { Typography } from "@novaescola/eva-react-v2/lib/Typography";

import { useInView } from "../../hooks/useInView";

const BlackAwareness = () => {
  const blackAwarenessRef = useRef(null);

  const isInView = useInView(blackAwarenessRef);

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    const previewEventSent = window.dataLayer.filter(
      (el) =>
        el.label &&
        el.label ===
          "Jornalismo - Click - Bloco lateral - educação antirracista - bloco visualizado"
    );

    if (isInView && previewEventSent.length === 0) {
      window.dataLayer.push({
        event: "block_visualization",
        label:
          "Jornalismo - Click - Bloco lateral - educação antirracista - bloco visualizado",
      });
    }
  }, [isInView]);
  return (
    <div className="theme-block eva-card eva-bg-inst-50 eva-mb-06">
      <div className="eva-card-info">
        <Typography variant="title" size={6} className="eva-mb-04" asChild>
          <p ref={blackAwarenessRef}>
            <i className="fa-regular fa-star eva-mr-03 eva-body-2"></i>
            Consciência Negra o Ano Inteiro
          </p>
        </Typography>
        <StaticImage
          src="https://s3.us-east-1.amazonaws.com/teste.dev.novaescola.org.br/imagemBannerConscienciaNegraAnoInteiro.jpg"
          alt=""
          width={328}
          height={328}
          className="eva-mb-06"
        />
        <Typography variant="body" size={2} className="eva-mb-06">
          Aborde as relações étnico-raciais na escola para além do 20 de
          novembro
        </Typography>
        <Button variant="outline-primary" size="medium" asChild>
          <a
            type="button"
            className="eva-btn-full eva-mt-02"
            href="https://novaescola.org.br/tudo-sobre/escola-de-respeito/"
            onClick={() => {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: "cta_click",
                label:
                  "Jornalismo - Click - Bloco lateral - educação antirracista - clique no botão",
              });
            }}
          >
            VER CONTEÚDOS
          </a>
        </Button>
      </div>
    </div>
  );
};

export default BlackAwareness;
